import { useRef, useState } from 'react';
import { axiosInstance } from '../../App';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Save, Upload, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const FIELDS = [['name', 'Bedrijfsnaam'], ['kvk', 'KvK-nummer'], ['btw_id', 'Btw-id'], ['address', 'Adres'], ['postal_code', 'Postcode'], ['city', 'Plaats'], ['email', 'E-mail'], ['phone', 'Telefoon'], ['iban', 'IBAN'], ['bic', 'BIC'], ['payment_term_days', 'Betalingstermijn (dagen)'], ['default_btw', 'Standaard btw %']];

export default function EsquarcioSettings({ readOnly, settings, onSaved }) {
  const [form, setForm] = useState(settings || {});
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();
  if (settings && !form.id) setForm(settings);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const body = { ...form, payment_term_days: Number(form.payment_term_days) || 14, default_btw: Number(form.default_btw) || 21 };
      delete body.id; delete body.created_at; delete body.updated_at;
      await axiosInstance.put('/esquarcio/settings', body);
      toast.success('Bedrijfsgegevens opgeslagen'); onSaved?.();
    } catch (err) { toast.error(err.response?.data?.detail || 'Opslaan mislukt'); } finally { setSaving(false); }
  };
  const uploadLogo = async (e) => {
    const f = e.target.files?.[0]; e.target.value = ''; if (!f) return;
    setUploading(true);
    const fd = new FormData(); fd.append('file', f);
    try { const r = await axiosInstance.post('/esquarcio/settings/logo', fd); setForm({ ...form, logo_url: r.data.logo_url }); toast.success('Logo bijgewerkt'); onSaved?.(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Logo uploaden mislukt'); } finally { setUploading(false); }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="esq-settings">
      <Card className="border-gray-200 shadow-sm lg:col-span-2"><CardContent className="p-5">
        <form onSubmit={save} className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {FIELDS.map(([k, l]) => (
            <div key={k}><Label className="text-xs">{l}</Label><Input value={form[k] ?? ''} disabled={readOnly} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`esq-setting-${k}`} /></div>
          ))}
          <div className="md:col-span-2"><Label className="text-xs">Tekst onderaan de factuur</Label><textarea value={form.invoice_footer || ''} disabled={readOnly} onChange={(e) => setForm({ ...form, invoice_footer: e.target.value })} rows={3} className="w-full border rounded-md px-3 py-2 text-sm" data-testid="esq-setting-invoice_footer" /></div>
          {!readOnly && <div className="md:col-span-2 flex justify-end"><Button type="submit" disabled={saving} className="bg-[#0f3b57] hover:bg-[#0b2d43]" data-testid="esq-settings-save">{saving ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Save className="w-4 h-4 mr-1" />} Opslaan</Button></div>}
        </form>
      </CardContent></Card>
      <Card className="border-gray-200 shadow-sm"><CardContent className="p-5 space-y-3">
        <p className="text-sm font-semibold text-gray-800">Logo</p>
        <div className="bg-white border rounded-xl p-4 flex items-center justify-center min-h-[120px]"><img src={form.logo_url || '/esquarcio-logo.jpg'} alt="Logo Esquarcio" className="max-h-24 object-contain" data-testid="esq-settings-logo" /></div>
        <p className="text-xs text-gray-500">Dit logo staat op de facturen van Esquarcio. Minimalistisch, petrolblauw op wit.</p>
        {!readOnly && (<>
          <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={uploadLogo} data-testid="esq-logo-input" />
          <Button variant="outline" onClick={() => fileRef.current?.click()} disabled={uploading} className="w-full" data-testid="esq-logo-upload-btn">{uploading ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Upload className="w-4 h-4 mr-1" />} Ander logo uploaden</Button>
        </>)}
      </CardContent></Card>
    </div>
  );
}
